import React from 'react';
import pick from 'lodash/pick';
import EditableSection from 'project/containers/brief_editable_section';
import { getVisibleBriefQuestions } from 'pap/utils';

/**
 * Execution brief section.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const Execution = ({ project, canEdit }) => {
  const briefQuestions = getVisibleBriefQuestions(project);
  /* exclude questions present in other sections */
  const items = briefQuestions.filter((q) => (
    !["industry", "company", "file_upload", "description"].includes(q.name)
  ))
  return (<EditableSection canEdit={canEdit} title="Execution" items={items} project={project}/>)
}

export default Execution



// WEBPACK FOOTER //
// ./project/components/brief/execution.jsx